/* eslint-disable max-len */
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MailIcon } from "@heroicons/react/outline";

const ForgotPasswordSuccess = () => (
	<Card className="my-5">
		<Card.Body className="p-5 text-center">
			<div className="mt-4 mb-3">
				<MailIcon className="i i-4x text-green" />
			</div>

			<h3 className="text-blue mb-4">
				Check your E-mail.
			</h3>

			<p className="ms-auto me-auto" style={{ maxWidth: "400px" }}>
				If your email address is registered with our system, you will receive an email to reset your password. If you do not receive this email, please Contact Us.
			</p>

			<Link to="/login">
				{"← Back to Login"}
			</Link>
		</Card.Body>
	</Card>
);

export default ForgotPasswordSuccess;
